import { leer, guardar } from './almacen';

export interface Reciente {
  case_id: string;
  tema: string;
  cliente?: string | null;
  visto: string;
}

const CLAVE = 'recientes';
const MAX = 8;

export function leerRecientes(): Reciente[] {
  return leer<Reciente[]>(CLAVE, []);
}

export function registrarReciente(r: Omit<Reciente, 'visto'>): void {
  const lista = leerRecientes().filter((x) => x.case_id !== r.case_id);
  lista.unshift({ ...r, visto: new Date().toISOString() });
  guardar(CLAVE, lista.slice(0, MAX));
}
